module.exports = __webpack_public_path__ + "asset/image-ic_category_25-0d439105b2ca3fa5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_25.svg
// module id = 0QVQ
// module chunks = 0